import Avatar from '@material-ui/core/Avatar'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React from 'react'
import author from '../../components/images/me.jpeg'

const styles = theme => ({
  container: {
    display: 'flex',
    margin: 25,
    [theme.breakpoints.down('xs')]: {
      margin: 18,
    },
  },
  title: { marginTop: '.35em' },
  avatar: {
    marginRight: 15,
  },
  text: {
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
})

class BlogDateAuthor extends React.Component {
  render() {
    const { classes } = this.props
    const post = this.props.post

    const date = new Date(post.date)

    var months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]
    const mounth = months[date.getMonth()]
    const year = date.getFullYear()
    const day = date.getDate()

    return (
      <div className={classes.container}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Avatar alt="calendar" src={author} className={classes.avatar} />
          <div>
            <div className={classes.text}>Michael Renaud,&nbsp;</div>
          </div>
          <div className={classes.text}>
            <span style={{ fontWeight: 300 }}>on</span> {mounth} {day}, {year}
          </div>
        </div>
      </div>
    )
  }
}

BlogDateAuthor.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(BlogDateAuthor)



// WEBPACK FOOTER //
// ./src/components/Blog/BlogDateAuthor.js